// src/services/newsService.js

import adminAxiosInstance from "./api/adminAxiosInstance";

/** Mapeamento de status para garantir consistência. O backend espera o nome do enum. */
const NewsStatus = {
  PENDENTE: 'PENDENTE',
  ATIVA: 'ATIVA',
  CANCELADA: 'CANCELADA',
};

/**
 * Busca todas as notícias que não foram excluídas.
 * @returns {Promise<Array>} Uma lista de notícias.
 */
const getAllNews = async () => {
    const response = await adminAxiosInstance.get('/news');
    return response.data;
};

/**
 * Cria uma nova notícia (ela será criada como PENDENTE no backend).
 * @param {object} newsData - Dados da notícia { mideaUrl, title, text, link }.
 * @returns {Promise<object>} A notícia criada.
 */
const createNews = async (newsData) => {
    const response = await adminAxiosInstance.post('/news', newsData);
    return response.data;
};

/**
 * Atualiza os dados de texto/imagem/link de uma notícia.
 * @param {number} id - O ID da notícia.
 * @param {object} newsData - Os dados a serem atualizados.
 * @returns {Promise<void>}
 */
const updateNews = async (id, newsData) => {
    const payload = { ...newsData, id: id };
    await adminAxiosInstance.put(`/news/${id}`, payload);
};

/**
 * Atualiza APENAS o status de uma notícia.
 * @param {number} id - O ID da notícia.
 * @param {string} newStatus - O novo status ('PENDENTE', 'ATIVA', 'CANCELADA').
 * @returns {Promise<void>}
 */
const updateNewsStatus = async (id, newStatus) => {
    await adminAxiosInstance.patch(`/news/${id}/status`, { status: newStatus });
};

/**
 * Marca uma notícia como EXCLUIDA (soft delete).
 * @param {number} id - O ID da notícia.
 * @returns {Promise<void>}
 */
const deleteNews = async (id) => {
    await adminAxiosInstance.delete(`/news/${id}`);
};

export const newsService = {
    getAllNews,
    createNews,
    updateNews,
    updateNewsStatus,
    deleteNews,
    NewsStatus, // Exportamos o enum para usar no componente
};